import React, { useMemo } from "react";
import { Input } from "antd";
import * as R from "ramda";

import {
  ANSWER_TYPES,
  DEFAULT_TYPE_ANSWERS
} from "../forms/QuestionForm/QuestionForm";

const CHARS_MAP = {
  á: "a",
  é: "e",
  í: "i",
  ó: "o",
  ú: "u"
};
const CHARS = R.pipe(
  R.keys,
  R.join("|")
)(CHARS_MAP);
const MATCHES = new RegExp(CHARS, "g");

const AnswerInput = ({ answerType, t, value, onChange, ...props }) => {
  function handleChange(e) {
    return onChange(
      R.pipe(
        R.path(["target", "value"]),
        R.toLower,
        R.replace(MATCHES, R.prop(R.__, CHARS_MAP)),
        R.replace(/[^0-9a-z|\s|ñ]/gi, "")
      )(e)
    );
  }

  const visibleValue = useMemo(
    () =>
      answerType === ANSWER_TYPES.yes_no.type
        ? value === DEFAULT_TYPE_ANSWERS[ANSWER_TYPES.yes_no.type][0].answer
          ? t("opportunity:process.stepTypes.chatbot.tree.yes")
          : t("opportunity:process.stepTypes.chatbot.tree.no")
        : value,
    [answerType, t, value]
  );

  return <Input value={visibleValue} onChange={handleChange} {...props} />;
};

export default AnswerInput;
